import styled from "styled-components";

export const StyledButton = styled.div<{
  textColor: string;
  backgroundColor: string;
  borderRadius: string;
}>`
  .ant-btn {
    width: 100%;
    font-family: "Urbanist";
    font-weight: 600;
    padding: 1.15rem;
    font-size: 1rem;
    border-radius: ${(props) => props.borderRadius};
    border: none;
    box-shadow: none;
    background: ${(props) => props.backgroundColor};
    color: ${(props) => props.textColor};
  }

  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background: ${(props) => props.backgroundColor};
    color: ${(props) => props.textColor};
    opacity: 0.7;
  }
`;
